/**
 * SHA-256 of an arbitrary UTF-8 string, returned as lowercase hex.
 *
 * Used by the thumbnail pipeline to compute `contentHash` over the page's
 * full HTML so the API can reject stale uploads (`STALE_THUMBNAIL`) and so
 * the client can detect when a cached PNG no longer matches its source.
 */
export async function sha256Hex(input: string): Promise<string> {
  const bytes = new TextEncoder().encode(input);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  const view = new Uint8Array(digest);
  let hex = '';
  for (let i = 0; i < view.length; i++) {
    hex += view[i].toString(16).padStart(2, '0');
  }
  return hex;
}
